module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-card"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_c('div', {
    staticClass: "icon-wrap"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
    }
  })])]), _vm._v("\n      Your Account Health\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "featured-gate",
    class: _vm.isFeaturedMerchant ? '' : 'not-eligible'
  }, [_c('div', {
    staticClass: "featured-gate-icon",
    class: _vm.isFeaturedMerchant ? '' : 'critical'
  }, [(_vm.isFeaturedMerchant) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })]) : _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "featured-gate-label"
  }, [_vm._v("Featured Merchant: " + _vm._s(_vm.isFeaturedMerchant ? 'Eligible' : 'Not Eligible'))]), _vm._v(" "), _c('div', {
    staticClass: "featured-gate-sub"
  }, [_vm._v(_vm._s(_vm.isFeaturedMerchant ? 'You can compete for the Buy Box on this ASIN' : 'You cannot win the Buy Box on this ASIN'))])]), _vm._v(" "), _c('span', {
    staticClass: "featured-gate-code"
  }, [_vm._v("IsFeaturedMerchant: " + _vm._s(_vm.isFeaturedMerchant ? 'true' : 'false'))])]), _vm._v(" "), ((_vm.accountHealth.metrics || []).length) ? _c('div', {
    staticClass: "health-metrics"
  }, _vm._l(((_vm.accountHealth.metrics || [])), function(metric, index) {
    return _c('div', {
      key: index,
      staticClass: "health-metric"
    }, [_c('span', {
      staticClass: "health-metric-name"
    }, [_vm._v(_vm._s(metric.name))]), _vm._v(" "), _c('span', {
      staticClass: "health-metric-value",
      class: metric.status
    }, [_vm._v(_vm._s(metric.value) + " "), _c('span', {
      staticClass: "threshold"
    }, [_vm._v(_vm._s(metric.threshold))])])])
  }), 0) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "health-note"
  }, [_vm._v("\n    These metrics govern your "), _c('strong', [_vm._v("Featured Merchant")]), _vm._v(" status. If ODR exceeds 1%, Amazon can revoke Buy Box eligibility account-wide — "), _c('code', [_vm._v("IsFeaturedMerchant")]), _vm._v(" flips to "), _c('code', [_vm._v("false")]), _vm._v(" and you cannot win any Buy Box regardless of price.\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e4897d02!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product-details/AccountHealth.vue
// module id = 819
// module chunks = 2